import { BaseError } from '@dynamic-labs-sdk/client';

export class NotSuiProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_sui_provider_error',
      docsUrl: null,
      name: 'NotSuiProviderError',
      shortMessage: 'Provider is not a Sui wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
